import React from 'react';
import { Modal, ModalTitle, ModalBody, ModalFooter } from '@vds/modals';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Notification } from '@vds/notifications';

import Button from '../Button';
import './reviewModal.css';
import { checkIsMidnight, isMobile, isTablet } from '../Helpers';

const StyledStickyContainer = styled.div`
  position: sticky;
  top: 0;
  z-index: 50;
`;

class ReviewOrderModal extends React.PureComponent {
  componentDidUpdate() {
    // accessibility fix to override aem css property
    if (
      this.props.name === 'customerAgreement' &&
      document.getElementsByClassName('simpleDesignAccessibility')?.[0]?.style?.visibility === 'hidden'
    ) {
      document.getElementsByClassName('simpleDesignAccessibility')[0].style.visibility = 'visible';
    }
  }

  render() {
    const { props } = this;

    const scrollMessage = 'Scroll down to the end to read the agreement and activate the button.';

    let agreeText = 'Agree and Continue';
    if (checkIsMidnight() && props.name === 'verizonHomeDeviceProtectITTKAgreement') {
      agreeText = 'Continue';
    }

    return (
      <>
        <div className="Addonhomemodal">
          <Modal
            ariaLabel={props.ariaLabel}
            closeButton={props.closeButton}
            customScroll={props.customScroll}
            disableOutsideClick={props.disableOutsideClick}
            showCloseButton={props.showCloseButton}
            hideCloseButton={props.hideCloseButton}
            opened={props.opened}
            onOpenedChange={props.onOpenedChange}
            showModal={props.showModal}
            className={props.className}
            id={props.id}
            contentContainer={props.contentContainer}
          >
            {props.name === 'customerAgreement' && !props.enableAgreeContBtn && (
              <StyledStickyContainer>
                <Notification type="info" title={scrollMessage} disableAnimation hideCloseButton fullBleed={false} inline={false} disableFocus />
              </StyledStickyContainer>
            )}

            <ModalTitle>{props.modalTitle}</ModalTitle>

            <ModalBody>
              <div className="reviewOrderModelBodyContainer">{props.modalBody}</div>
              {(props.name === 'customerAgreement' || props.name === 'verizonHomeDeviceProtectITTKAgreement') && (
                <div className="modelfooter" style={{ bottom: isMobile() || isTablet() ? '-16px' : 0 }}>
                  <Button
                    id="agreeCustTerms"
                    onClick={props.acceptAgreement}
                    aria-label="Agree and continue click"
                    disabled={!props.enableAgreeContBtn}
                    data-track='{"type": "link", "name": "Agree and continue click", "data":{"page":{"throttle":"nsa version|vhi|TS" }}}'
                  >
                    {agreeText}
                  </Button>
                </div>
              )}
            </ModalBody>
            <ModalFooter>
              <div className="automation-model-footer" />
            </ModalFooter>
          </Modal>
        </div>
      </>
    );
  }
}

ReviewOrderModal.propTypes = {
  ariaLabel: PropTypes.string,
  closeButton: PropTypes.func,
  customScroll: PropTypes.func,
  disableOutsideClick: PropTypes.func,
  showCloseButton: PropTypes.bool,
  hideCloseButton: PropTypes.bool,
  opened: PropTypes.bool,
  onOpenedChange: PropTypes.func,
  showModal: PropTypes.func,
  className: PropTypes.array,
  modalBody: PropTypes.string,
  modalTitle: PropTypes.string,
  name: PropTypes.string,
  acceptAgreement: PropTypes.func,
  id: PropTypes.any,
  contentContainer: PropTypes.any,
  enableAgreeContBtn: PropTypes.bool,
};

export default ReviewOrderModal;
